import {AvalancheReelsDropNewState} from '@fantasmagames/slot/src/modules/reels/avalanche/states/AvalancheReelsDropNewState';
import {ReelConstants} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {AvalancheReelsEvents} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsEvents';
import {AvalancheReelsModule} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsModule';

export class GameAvalancheReelsDropNewState extends AvalancheReelsDropNewState {

	protected dropNewSymbols(): void {
		this.view.dropNew(this.module.logic.getSpinResult().reels, ReelConstants.ROW_AMOUNT);
		this.emit(AvalancheReelsEvents.ALL_REELS_DROP_NEW_STARTED);
	}

	protected onAllReelsDroppedNew(): void {
		this.module.gotoState(AvalancheReelsModule.BASIC_STATE);
	}
}



// WEBPACK FOOTER //
// ./src/avalanche/states/GameAvalancheReelsDropNewState.ts